export enum UserType {
  employee = 1,
  plusOne = 2,
}

export const isEmployee = (userType?: UserType) =>
  Boolean(userType) && userType === UserType.employee;

export const isPlusOne = (userType?: UserType) =>
  Boolean(userType) && userType === UserType.plusOne;

export const isAdmin = (permissions: string[] | undefined): boolean => {
  if (permissions && permissions.length > 0) {
    return ['admin', 'superadmin'].some(p => permissions.includes(p));
  }

  return false;
};
